export default __webpack_public_path__ + "img/favicons/android-chrome-192x192.png";